module.exports = __webpack_public_path__ + "static/customdevices-4d6d1c89a26f00a811da4318f5b4edd9.png";